export const MODEL_MAP = {
  'gpt-5.5':     'GPT-5.5',
  'gpt-5.5-pro': 'GPT-5.5 Pro',
  'gpt-5.4':     'GPT-5.4',
  'gpt-5.4-mini':  'GPT-5.4 Mini',
  'gpt-5.4-nano':  'GPT-5.4 Nano',
  'gpt-5':       'GPT-5',
  'gpt-4.1':     'GPT-4.1',
  'gpt-4o':      'GPT-4o',
  'gpt-3.5-turbo': 'GPT-3.5 Turbo',
};

export const MODEL_DESCRIPTIONS = {
  'gpt-5.5':
    'GPT-5.5 - Flagship frontier model with the strongest overall performance for reasoning, coding, creativity, and multimodal tasks.',

  'gpt-5.5-pro':
    'GPT-5.5 Pro - Premium high-capability version of GPT-5.5 optimized for advanced reasoning, complex coding, and agentic workflows.',

  'gpt-5.4':
    'GPT-5.4 - Balanced next-generation model offering strong reasoning, speed, and cost efficiency for most production workloads.',

  'gpt-5.4-mini':
    'GPT-5.4 Mini - Faster and more affordable GPT-5.4 variant designed for scalable assistants, chat apps, and everyday production tasks.',

  'gpt-5.4-nano':
    'GPT-5.4 Nano - Ultra-fast and highly cost-efficient lightweight model optimized for simple tasks, classification, extraction, and automation.',

  'gpt-5':
    'GPT-5 - General-purpose GPT-5 model delivering excellent overall performance across chat, coding, and content generation.',

  'gpt-4.1':
    'GPT-4.1 - Powerful GPT-4–series model with strong coding, instruction-following, and long-context capabilities.',

  'gpt-4o':
    'GPT-4o - Multimodal omni model supporting text, images, audio, and realtime interactions with balanced speed and intelligence.',

  'gpt-3.5-turbo':
    'GPT-3.5 Turbo - Legacy fast and lightweight model offering reliable low-cost performance for basic conversational and text tasks.',
};
